import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class SettingsService {

  userid: string;
  username: string;
  streamid: string;
 
//  jumpedIn: boolean;

  connectionConstraints = {
    audio: new BehaviorSubject<boolean>(true),
    video: new BehaviorSubject<boolean>(true),
    screen: new BehaviorSubject<boolean>(false),
  }

  connectionConstraintsCast = {
    audioCast: this.connectionConstraints.audio.asObservable(),
    videoCast: this.connectionConstraints.video.asObservable(),
    screenCast: this.connectionConstraints.screen.asObservable()
  }

  startFormOpen = new BehaviorSubject<boolean>(true);
  startFormOpenCast = this.startFormOpen.asObservable();

  jumpedIn = new BehaviorSubject<boolean>(true);
  jumpedInCast = this.jumpedIn.asObservable();
  
  primaryLocked = new BehaviorSubject<boolean>(false);
  primaryCast = this.primaryLocked.asObservable();

  screenshareLocked = new BehaviorSubject<boolean>(true);
  screenshareCast = this.screenshareLocked.asObservable();

  screenshareOpen = new BehaviorSubject<boolean>(false);
  screenshareOpenCast = this.screenshareLocked.asObservable();

  layout = new BehaviorSubject<string>("default");
  cast = this.layout.asObservable();

  chatLock = new BehaviorSubject<boolean>(false);
  chatLockCast = this.chatLock.asObservable();

  audioOnly = new BehaviorSubject(false);
  audioOnlyCast = this.audioOnly.asObservable();

  bugReportFormOpen = new BehaviorSubject<boolean>(false);
  bugReportFormOpenCast = this.bugReportFormOpen.asObservable();

  screenShareIsOpen = new BehaviorSubject<boolean>(false);
  screenShareIsOpenCast = this.screenShareIsOpen.asObservable();


  DoubleClickSupress = false;



 setScreenshareIsOpen = (set) => {
   this.screenShareIsOpen.next(set);
 }

  setAudioOnly = (set) => {
    this.audioOnly.next(set);
  }

  setChatLock = (set) => {
    this.chatLock.next(set);
  }

  toggleReportForm = () => {
    
    let toggle = !this.bugReportFormOpen.value;
    this.bugReportFormOpen.next(toggle);
  }

  toggleVideoContraint = () => {
    let toggle = !this.connectionConstraints.video.value;
    this.connectionConstraints.video.next(toggle);
  }

 toggleAudioContraint = () => {
    let toggle = !this.connectionConstraints.audio.value;
    this.connectionConstraints.audio.next(toggle);
  }


  changeScreenshareOpenState = (state) => {
    if(this.screenshareOpen.next) {
      this.screenshareOpen.next(state);
    }
  }

  changeStartForm = (state) => {
    if(this.startFormOpen.next) {
      this.startFormOpen.next(state);
    }
  }

  changeJumpedInStatus = (status) => {
    if(this.jumpedIn.next){ //stops double run error
      this.jumpedIn.next(status);
    }
  }

  changeLayout = (layoutName) => {
    this.layout.next(layoutName);
  }

  getId = () => {
    return this.userid;
  }


  getUsername = () => {
    return this.username;
  }

  getStreamId = () => {
    return this.streamid;
  }

  setPrimaryMode = (mode) => {
    if(this.primaryLocked.next) { //stops double run error
      this.primaryLocked.next(mode);
    }
  }

  setScreenshareLock = (mode) => {
    if(this.screenshareLocked.next){
      this.screenshareLocked.next(mode)
    }
  }

  toggleScreenshareLock = () => {
    if(this.screenshareLocked.value === false) {
      this.screenshareLocked.next(true);
    } else if(this.screenshareLocked.value === true) {
      this.screenshareLocked.next(false);
    } else {
      return
    }
  }

  togglePrimaryLock = () => {
    console.log(this.primaryLocked.value)
   if(this.primaryLocked.value === false) {
     this.primaryLocked.next(true);
   } else if(this.primaryLocked.value === true) {
     this.primaryLocked.next(false);
   } else {
     return
   }
  }


  setUsername = (name) => {
    this.username = name;
  }

  setStreamId = (id) => {
    this.streamid = id;
  }

  setUserId = (id) => {
    this.userid = id;
  }
  


  constructor() {
    this.username = "";
    //this.jumpedIn = true;

    

   }

}
